"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));
var _react = _interopRequireWildcard(require("react"));
var _wbmInputs = require("wbm-inputs");
var _headerText = require("../../components/formElements/headerText");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Slider = exports.Slider = function Slider(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    scrollReset = _useState2[0],
    setReset = _useState2[1];
  var slider = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    overFlown = _useState4[0],
    setOverFlown = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loaded = _useState6[0],
    setLoaded = _useState6[1];
  function handleResize() {
    hideButton(document.getElementById(props.sliderKey));
  }
  function hideButton(element) {
    if (loaded && element) {
      if (element.scrollWidth > element.offsetWidth) {
        setOverFlown(true);
      } else {
        setOverFlown(false);
      }
    }
  }
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleResize);
    if (!loaded) {
      setLoaded(true);
    } else {
      hideButton(document.getElementById(props.sliderKey));
    }
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbm-slider"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_headerText.CardHeader, {
    text: props.headerText
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbm-slider-child",
    id: props.sliderKey,
    ref: slider,
    onScroll: function onScroll(event) {
      var element = event.target;
      var showRight = element.scrollWidth > element.offsetWidth && slider.current.clientWidth - slider.current.scrollWidth + slider.current.scrollLeft < -30; // width of the button
      setReset(element.scrollWidth > element.offsetWidth && !showRight);
    }
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: overFlown ? "btn-primary round scroll-filter-button" : "btn-primary round scroll-filter-button no-overflown-content",
    style: {
      position: 'absolute',
      zIndex: '1'
    },
    "aria-label": "scroll slider",
    onClick: function onClick() {
      slider.current.scroll({
        top: slider.current.scrollTop,
        left: scrollReset ? 0 : Math.min(slider.current.scrollWidth, slider.current.scrollLeft + slider.current.offsetWidth),
        behavior: "smooth"
      });
    }
  }, !scrollReset && /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null), scrollReset && /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null)), props.sliderObject && props.sliderObject.map(function (component, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "slider-item slider-filter-container"
    }, component))
    //<div className="slider-item">
    //<MerchandiseSliderItem {...(component as IMerchandiseSliderItemProps)}
    //    />
    //    </div>
    ;
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginRight: 44
    }
  })));
};
//# sourceMappingURL=slider.js.map